import React from 'react';
import { useForm } from 'react-hook-form';
import { EqualEmploymentOpportunity } from '../../utils/formNames';
import { getFormData } from '../../utils/sessionStorage';
import { FORM_HOST } from '../../utils/constants';
import EnrollmentForm from './EnrollmentForm';
import EnrollmentFormSelectInput from '../FormInputs/FormSelectInput';
import EnrollmentFormRadioListInput from '../FormInputs/FormRadioListInput';
import EnrollmentFormError from '../FormInputs/FormError';

const formName = EqualEmploymentOpportunity;
// Currently this form-handler url is unused, as the slowSubmit prop
// on the <EnrollmentForm> component bypasses normal submission to
// submit to the SlowForm handler.  This is to ensure data is fully
// submitted to Pardot before navigation away. This form url is kept
// here in case future pages are added, and the slowSubmit prop removed.
const pardotFormUrl = `${FORM_HOST}/l/772833/2020-04-20/5hzb3l`;
const callbackLocations = {
  success_location: `${FORM_HOST}/l/772833/2020-07-06/7k97tj/772833/58655/equal_employment_opportunity_success.js`,
  error_location: `${FORM_HOST}/l/772833/2020-07-06/7k97tg/772833/58653/equal_employment_opportunity_error.js`,
};

const EqualEmploymentOpportunityForm = () => {
  const { register, handleSubmit, formState, errors } = useForm({
    mode: 'onBlur',
    submitFocusError: false,
  });

  const previousData = getFormData(formName);

  return (
    <EnrollmentForm
      formName={formName}
      callbackLocations={callbackLocations}
      slowSubmit
      submitText="Finish"
      submitId="submit-button"
      actionUrl={pardotFormUrl}
      formValid={formState.isValid}
      validationHandler={handleSubmit}
    >
      <legend>DEI Survey (Optional)</legend>
      <p>
        This section helps us fulfill our mission of supporting a more inclusive workforce in tech and is used for
        statistical purposes only. Your answers do not affect your consideration for the Pathrise program and are 100%
        optional.
      </p>
      <hr />
      <p>Please identify your gender</p>
      <EnrollmentFormRadioListInput
        name="gender"
        id="male-gender"
        label="Male"
        value="Male"
        defaultValue={previousData.gender}
        inputRef={register}
      />
      <EnrollmentFormRadioListInput
        name="gender"
        id="female-gender"
        label="Female"
        value="Female"
        defaultValue={previousData.gender}
        inputRef={register}
      />
      <EnrollmentFormRadioListInput
        name="gender"
        id="non-binary-gender"
        label="Non-Binary"
        value="Non-Binary"
        defaultValue={previousData.gender}
        inputRef={register}
      />
      <EnrollmentFormRadioListInput
        name="gender"
        id="decline-gender"
        label="Decline to Self Identify"
        value="Decline to Self Identify"
        defaultValue={previousData.gender}
        inputRef={register}
      />
      <EnrollmentFormError errorField={errors.gender} blockError />
      <EnrollmentFormSelectInput
        name="race"
        label="Please identify your race"
        defaultValue={previousData.race}
        error={errors.race}
        inputRef={register}
      >
        <option value="Non-Hispanic White or Euro-American">Non-Hispanic White or Euro-American</option>
        <option value="Black, Afro-Caribbean, or African American">Black, Afro-Caribbean, or African American</option>
        <option value="Latino or Hispanic American">Latino or Hispanic American</option>
        <option value="East Asian or Asian American">East Asian or Asian American</option>
        <option value="South Asian or Indian American">South Asian or Indian American</option>
        <option value="Pacific Islander">Pacific Islander</option>
        <option value="Middle Eastern or Arab American">Middle Eastern or Arab American</option>
        <option value="Native American or Alaskan Native">Native American or Alaskan Native</option>
        <option value="Two or More Races">Two or More Races</option>

        <option value="Decline to Self Identify">Decline to Self Identify</option>
      </EnrollmentFormSelectInput>
      <EnrollmentFormError errorField={errors.race} />
      <p>Please identify your veteran status</p>
      <EnrollmentFormRadioListInput
        name="veteran"
        id="is-veteran"
        label="I am a protected veteran"
        value="Protected Veteran"
        defaultValue={previousData.veteran}
        inputRef={register}
      />
      <EnrollmentFormRadioListInput
        name="veteran"
        id="is-not-veteran"
        label="I am not a protected veteran"
        value="Not Protected Veteran"
        defaultValue={previousData.veteran}
        inputRef={register}
      />
      <EnrollmentFormRadioListInput
        name="veteran"
        id="decline-veteran"
        label="Decline to Self Identify"
        value="Decline to Self Identify"
        defaultValue={previousData.veteran}
        inputRef={register}
      />
      <EnrollmentFormError errorField={errors.veteran} blockError />
    </EnrollmentForm>
  );
};

export default EqualEmploymentOpportunityForm;
